import { render, staticRenderFns } from "./TimeLeft.vue?vue&type=template&id=5c32b469"
import script from "./TimeLeft.vue?vue&type=script&lang=js"
export * from "./TimeLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports